const bank = [{
  desc: '根据银行卡号查询银行信息',
  options: {
    url: '/bank/queryBankCardAttr',
    method: 'post'
  }
}, {
  desc: '获取银行卡列表',
  options: {
    url: '/bank/GetBankCard',
    method: 'post'
  }
}, {
  desc: '获取公司卡列表',
  options: {
    url: '/bank/getBusinessBankCard',
    method: 'post'
  }
}, {
  desc: '根据开户行code和name查询该银行的所有支行',
  options: {
    url: '/bank/queryAccountBank',
    method: 'post'
  }
}, {
  desc: '获取银行信息',
  options: {
    url: '/bank/queryBank',
    method: 'post'
  }
}, {
  desc: '新增或编辑银行卡',
  options: {
    url: '/bank/SaveBankCard',
    method: 'post'
  }
}]
export default bank



// WEBPACK FOOTER //
// ./src/api/bank.js